import { Card, Grid, Icon, MenuItem } from '@material-ui/core';
import { ConfigFieldControl, ConfigTextField, IconPicker } from '@sierralabs/core-ui';
import { CardTitle } from '@sierralabs/core-ui';
import React from 'react';
import { useConfigComponent } from '../../hooks/component/useConfigComponent';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import { useSiteContext } from '../../SiteContext';
import ComponentRenderer from '../renderers/ComponentRenderer';
import { SiteComponent } from '../SiteComponentPlugin';
import { SiteComponentStackConfigurator } from './SiteComponentStackPlugin';
export const SiteDashboardCard = props => {
    var _a;
    const component = useSubscribeComponentChanges(SiteDashboardCardPlugin, props);
    const { xs, sm, md, lg, icon, title = 'Untitled' } = component.props || {};
    const { isHover, hoverProps } = useSiteContext();
    const classes = ['site-card'];
    if (isHover(component)) {
        classes.push('component-hover');
    }
    return (React.createElement(SiteComponent, Object.assign({ plugin: SiteDashboardCardPlugin }, props),
        React.createElement(Grid, { item: true, xs: xs, sm: sm, md: md, lg: lg },
            React.createElement(Card, Object.assign({ className: classes.join(' ') }, hoverProps(component)),
                (icon || title) && (React.createElement(CardTitle, null,
                    icon && React.createElement(Icon, { className: 'icon' }, icon),
                    title)), (_a = component.children) === null || _a === void 0 ? void 0 :
                _a.map(child => (React.createElement(ComponentRenderer, { key: child.id, component: child })))))));
};
export const SiteDashboardCardConfigurator = props => {
    var _a, _b;
    const { component, update } = useConfigComponent(props.component);
    return (React.createElement(React.Fragment, null,
        ['xs', 'sm', 'md', 'lg'].map(size => {
            var _a;
            return (React.createElement(ConfigFieldControl, { key: size },
                React.createElement(ConfigTextField, { fullWidth: true, type: 'number', label: size.toUpperCase(), value: ((_a = component.props) === null || _a === void 0 ? void 0 : _a[size]) || '', onChange: event => {
                        const value = event.target.value;
                        update(`props.${size}`, value === 'auto' ? 'auto' : parseInt(value));
                    } }, ['auto', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(spacing => (React.createElement(MenuItem, { key: spacing, value: spacing }, spacing))))));
        }),
        React.createElement(ConfigFieldControl, null,
            React.createElement(IconPicker, { value: ((_a = component.props) === null || _a === void 0 ? void 0 : _a.icon) || '', onChange: icon => {
                    update('props.icon', icon);
                } }),
            React.createElement(ConfigTextField, { fullWidth: true, label: 'Title', value: ((_b = component.props) === null || _b === void 0 ? void 0 : _b.title) || '', onChange: event => {
                    update('props.title', event.target.value);
                } })),
        React.createElement(SiteComponentStackConfigurator, { component: props.component })));
};
export const SiteDashboardCardPlugin = {
    name: 'Site Dashboard Card',
    type: 'site-dashboard-card',
    slots: [
        {
            name: 'Card Content',
            type: 'component-stack',
            slot: 'card-content'
        }
    ],
    component: SiteDashboardCard,
    configurator: SiteDashboardCardConfigurator
};
//# sourceMappingURL=SiteDashboardCardPlugin.js.map